import gql from "graphql-tag";

export default gql`
  query getBloombergJobs {
    getBloombergJobs {
      available
      jobs {
        id
        revision
        state
        definition {
          name
          identifiers
          category_ids
          request_kind
          schedule_id
          start_date
          end_date
          profile_id
          fields
          universe_hash
          definition_hash
        }
        created_at
        updated_at
      }
      message
    }
  }
`;